"use client";

import { useEffect, useState } from "react";
import { InfrastructureProjectsDirectory } from "./infrastructure-projects-directory";
import { MovieEngineDashboard } from "./movie-engine-dashboard";

type EditInfrastructureEvent = CustomEvent<{ applicationEntityKey?: string | null; projectId?: string | null }>;

export function RunyiEnterpriseRoot() {
  const [projectsOpen, setProjectsOpen] = useState(false);
  const [applicationEntityKey, setApplicationEntityKey] = useState<string | null>(null);
  const [projectId, setProjectId] = useState<string | null>(null);

  useEffect(() => {
    const openProjects = (event: Event) => {
      const detail = (event as EditInfrastructureEvent).detail;
      setApplicationEntityKey(detail?.applicationEntityKey ?? null);
      setProjectId(detail?.projectId ?? null);
      setProjectsOpen(true);
    };
    window.addEventListener("runyi:edit-infrastructure", openProjects);
    return () => window.removeEventListener("runyi:edit-infrastructure", openProjects);
  }, []);

  return (
    <>
      <MovieEngineDashboard />
      <InfrastructureProjectsDirectory
        open={projectsOpen}
        onClose={() => setProjectsOpen(false)}
        initialApplicationEntityKey={applicationEntityKey}
        initialProjectId={projectId}
      />
    </>
  );
}
